import installRegexpEscapeShim from 'regexp.escape/shim';
installRegexpEscapeShim();
